<template>
  <div v-if="sizes && activeSize" class="basket-kit-sku">
    <DefSelectWrapper>
      <template #header>{{ activeSize.displayValue }}</template>
      <template #placeholder>{{ sizes.title }}</template>
      <span
        v-for="(item, i) in sizes.items"
        :key="item.value"
        :class="{ 'basket-kit-sku__item_disabled': item.disable || item.onOrder }"
        class="basket-kit-sku__item"
        @click="$emit('changeSize', item.detailPage)"
      >
        {{ item.displayValue }}
        <span v-if="item.disable || item.onOrder" class="basket-kit-sku__notAvailable">
          {{ getMessage(item) }}
        </span>
      </span>
    </DefSelectWrapper>
  </div>
</template>

<script setup lang="ts">
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import { defineProps, computed, defineEmits } from 'vue';
import { IMessages } from '@/interfaces/IMessages';
import { ISizes, ISize } from '@/interfaces/IProduct/ISkuMatrix';

import { useStore } from '@/store';

const { state, getters } = useStore();

defineEmits<{
  (e: 'changeSize', url: string): void;
}>();

const props = defineProps<{ messages: IMessages; sizes: ISizes | undefined }>();
const getMessage = (item: ISize) => {
  const { onOrder, outOfStock } = props.messages;
  if (item.onOrder) {
    return onOrder;
  }
  return outOfStock;
};

const activeSize = computed<ISize | undefined>(() => props?.sizes?.items?.find((el) => el.active));
</script>

<style lang="scss" scoped>
.basket-kit-sku {
  &__item {
    justify-content: space-between;
    &_disabled {
      color: var(--color-dark-grey);
    }
  }
  &__notAvailable {
    font-weight: 400;
    font-size: rem(10);
    line-height: 110%;
    color: var(--color-dark-grey);
    margin-left: 5px;
  }
}
</style>
